/**
 * 高德地图定位
 */

import Store from '../store/store'
import { getUrlDistance } from '../api/api';

const getLocation =function () {
    AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: false,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
        })

        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', onComplete);
        AMap.event.addListener(geolocation, 'error', onError);

        function onComplete(result) {
            // data是具体的定位信息,定位成功信息
            // console.log('定位成功信息：', result);
            let data = {
                lat: result.position.lat,
                lng: result.position.lng,
                province: result.addressComponent.province,
                city: result.addressComponent.city.replace("市",""),
                district: result.addressComponent.district
            };

            Store.commit("UPDATE_CHANGE_CITY",data)

            localStorage.setItem("city_data",JSON.stringify(data))

            Store.commit("UPDATE_CITY_LOCATION",true)
            localStorage.setItem("city_location",true)

            Store.commit("UPDATE_CURRENT_CITY",result.addressComponent.city.replace("市",""))
            localStorage.setItem("current_city",result.addressComponent.city.replace("市",""))
        }

        function onError(data) {
            // 定位出错,定位失败错误信息
            // console.log('定位失败错误：', data);
            // 调用ip定位,以下方法可以封装一个函数
            AMap.plugin('AMap.CitySearch', function () {
                var citySearch = new AMap.CitySearch();
                citySearch.getLocalCity(function (status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        // 查询成功，result即为当前所在城市信息
                        // console.log('通过ip获取当前城市：', result)
                        //逆向地理编码
                        AMap.plugin('AMap.Geocoder', function () {
                            var geocoder = new AMap.Geocoder({
                                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                                city: result.adcode
                            })

                            var lnglat = result.rectangle.split(';')[0].split(',');
                            geocoder.getAddress(lnglat, function (status, data) {
                                if (status === 'complete' && data.info === 'OK') {
                                    // result为对应的地理位置详细信息
                                    // console.log('通过ip获取当前地理位置：',data)

                                    let res = {
                                        lat: result.bounds.southwest.lat,
                                        lng: result.bounds.southwest.lng,
                                        province: data.regeocode.addressComponent.province,
                                        city: data.regeocode.addressComponent.city.replace("市",""),
                                        district: data.regeocode.addressComponent.district
                                    };

                                    Store.commit("UPDATE_CHANGE_CITY",res)
                                    localStorage.setItem("city_data",JSON.stringify(res))

                                    Store.commit("UPDATE_CITY_LOCATION",true)
                                    localStorage.setItem("city_location",true)
                                    
                                    Store.commit("UPDATE_CURRENT_CITY",data.regeocode.addressComponent.city.replace("市",""))
                                    localStorage.setItem("current_city",data.regeocode.addressComponent.city.replace("市",""))
                                }
                            })
                        })
                    }
                })
            })
        }
    })
}


/**
 * JS高德地图几何，计算两点间的实际距离
 */

const getDistance =function (one,two) {

        var p1 = one;
        var p2 = two;
        var dis = AMap.GeometryUtil.distance(p1, p2);
        var sum = (dis / 1000);

        // 小数点保留两位
        var val = Math.round(sum * 100) / 100
        var xsd = val.toString().split('.')
        if (xsd.length === 1) {
          val = val.toString() + '.00'
          return val
          // console.log(val);
        }
        if (xsd.length > 1) {
          if (xsd[1].length < 2) {
            val = val.toString() + '0'
          }
          return val
          // console.log(val);
        }

}

export {
    getLocation,
    getDistance
}
